import { Space } from "antd";

export const Planscolumns = (setAmount) => {
  return [
    // {
    //   title: "Circle",
    //   dataIndex: "circle",
    //   key: "circle",
    //   render: (text) => <a className="font-medium">{text}</a>,
    // },
    {
      title: "Plan",
      dataIndex: "plan_name",
      key: "plan_name",
      render: (text) => {
        return (
          <>
            <p className=" font-medium px-3 overflow-y-scroll">
              {text ? text.split(" ")[0] : "-"}
            </p>
          </>
        );
      },
    },
    // {
    //   title: "Data",
    //   dataIndex: "data",
    //   key: "data",
    //   render: (text) => <p style={{width:"100px"}} className=" font-medium">{text}</p>,
    // },
    {
      title: "Validity",
      dataIndex: "validity",
      key: "validity",
      render: (text) => <a className="font-medium">{text ?? "-"}</a>,
    },
    {
      title: "Description",
      dataIndex: "desc",
      key: "desc",
      render: (text) => {
        return (
          <>
            <p
              style={{ width: "300px" }}
              className="font-medium   px-3 overflow-y-scroll"
            >
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },

    {
      title: "Price",
      key: "rs",
      dataIndex: "rs",
      render: (text) => {
        return typeof text === "object" ? (
          <div className="flex justify-start flex-col items-center gap-2">
            {Object.keys(text).map((i, index) => (
              <p
                onClick={() => {
                
                    setAmount(text[i]);
        
                }}
                className="border font-medium text-xs w-20 cursor-pointer border-primary hover:bg-primary hover:text-bswhite font-bold transition-all text-center px-2 text-primary rounded-md"
              >
                {i}<br/> {text[i]} Rs.
              </p>
            ))}
          </div>
        ) : (
          <p
            onClick={() => {
              setAmount(text);
            }}
            className="border font-medium  cursor-pointer border-primary hover:bg-primary hover:text-bswhite font-bold transition-all text-center px-2 text-primary rounded-md"
          >
            RS. {text??"-"}
          </p>
        );
      },
    },
  ];
};
